import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useTheme from '../../theme';
import { recordStatisticsEvent } from '../../../../../services/statistics-service';

const Link = styled.a`
  width: 238px;
  padding: 12px 8px 12px;
  color: black;
  text-transform: uppercase;
  font-size: 17px;
  font-weight: 700;
  border-radius: 6px;

  ${props => props.theme.isROIMobile && `
    width: 100%;
  `};

  &:hover {
    color: black;
    background-color: #F1F5F9;
  }
`;

export default function ListenOptionLink({
  name, url, seriesId, position,
}) {
  const handleClick = () => {
    recordStatisticsEvent({
      event: 'third_party_service_button',
      statisticable: 'series',
      id: seriesId,
      page: window.location.pathname,
      custom_data: {
        section: 'series_header',
        page: 'series',
        position,
      },
    });
  };

  const optionClicked = e => {
    e && e.preventDefault();
    handleClick();
    window.location = url;
  };

  return (
    <Link href={url} theme={useTheme()} onClick={optionClicked}>
      {name}
    </Link>
  );
}

ListenOptionLink.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  seriesId: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
};
